import React from 'react';
import ScreensaverContainer from 'component/main/screensaver/ScreensaverContainer';

const MainPage = () => <ScreensaverContainer />;

export default MainPage;
